import { service } from "../utils/request";

// 优惠券
export function fullReductList(data) {
  return service({
    url: "fullreduction/agent.index/index",
    method: "post",
    data: data
  });
}
export function deletefullReduct(data) {
  return service({
    url: "fullreduction/agent.index/del",
    method: "post",
    data: data
  });
}
export function addfullReduct(data) {
  return service({
    url: "fullreduction/agent.index/add",
    method: "post",
    data: data
  });
}
export function editfullReduct(data) {
  return service({
    url: "fullreduction/agent.index/edit",
    method: "post",
    data: data
  });
}
export function detailfullReduct(data) {
  return service({
    url: "fullreduction/agent.index/detail",
    method: "post",
    data: data
  });
}